var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"lymphomap_main"},[_c('div',{staticClass:"lymphomap_wrp"},[_c('lymphomap-form')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }